import React from 'react';
import {
  FuelGridContainer,
  FuelGridItem,
  FuelSkeleton,
} from '@frete.com/fuel-react';
import SkeletonListAllTab from './SkeletonListAllTab';
import * as Styled from './SkeletonListAllTabStyles';

function SkeletonAllTab() {
  const numberOfLinesRender = 5;

  function renderLines() {
    return Array.from({ length: numberOfLinesRender }, (_, index) => (
      <SkeletonListAllTab
        key={`SkeletonListAllTab-${index}`}
        borderBottom={index !== numberOfLinesRender}
        marginBottom={index === numberOfLinesRender}
      />
    ));
  }

  return (
    <Styled.Wrapper data-testid="loading-all-tab-Desktop">
      <FuelGridContainer gapRow={24} style={{ margin: 0 }}>
        <FuelGridItem sm={4} md={6} lg={8} xlg={8}>
          <FuelSkeleton
            shape="square"
            size="custom"
            width="300px"
            height="24px"
            style={{ marginTop: 12, marginBottom: 24 }}
          />
          {renderLines()}
        </FuelGridItem>
        <FuelGridItem sm={2} md={2} lg={4} xlg={4}>
          <Styled.WrapperMap>
            <FuelSkeleton
              shape="square"
              size="custom"
              width="100%"
              height="100%"
            />
          </Styled.WrapperMap>
        </FuelGridItem>
      </FuelGridContainer>
    </Styled.Wrapper>
  );
}

export default SkeletonAllTab;
